import React, { useState, useEffect, useRef } from 'react';
import CategoryBlock from './categoryBlock';
import { Link } from 'react-router-dom';

const Categories = () => {
  const [appear, setAppear] = useState(false);
  const [appearbtn, setAppearbtn] = useState(false);
  const categoriesRef = useRef();

  const handleScroll = () => {
    var top = window.pageYOffset;

    var introOffset;
    if (window.innerWidth < 450)
      introOffset = categoriesRef.current.offsetTop - window.innerHeight + 320;
    else
      introOffset = categoriesRef.current.offsetTop - window.innerHeight + 320;

    if (top >= introOffset) setAppear(true);
    else setAppear(false);

    if (top >= introOffset + 70) setAppearbtn(true);
    else setAppearbtn(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <React.Fragment>
      <div
        ref={categoriesRef}
        className={
          'row'
          // appear ? 'row categorieshome' : 'row categorieshome hide-btn'
        }
      >
        <CategoryBlock
          label='Cold Drink'
          Background='/img/cat1.jpg'
          appear={appear}
          delay={0}
          url='Cold drink'
        />

        <CategoryBlock
          label='Juices'
          Background='/img/juices.jpg'
          appear={appear}
          delay={0.2}
          url='Juice'
        />
        <CategoryBlock
          label='Water'
          Background='/img/cat2.jpg'
          appear={appear}
          delay={0.4}
          url='Water'
        />
      </div>

      <div className='overflow-hide'>
        <div className={appearbtn ? 'category-btn' : 'category-btn hide-btn'}>
          <Link to='/products/'>
            <button className='explore-categories'>Explore Categories</button>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Categories;
